import React, { createContext, useContext, useMemo } from 'react'

import { useJoyrideLogic } from './hooks/useJoyrideLogic'

type JoyrideContextValue = ReturnType<typeof useJoyrideLogic>

const JoyrideContext = createContext<JoyrideContextValue | null>(null)

export const JoyrideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const joyride = useJoyrideLogic()

  const value = useMemo(() => joyride, [joyride.run, joyride.stepIndex])

  return <JoyrideContext.Provider value={value}>{children}</JoyrideContext.Provider>
}

export const useJoyride = () => {
  const ctx = useContext(JoyrideContext)
  if (!ctx) throw new Error('useJoyride must be used inside <JoyrideProvider>')
  return ctx
}
